export { default as titleTop } from './titleTop.vue'; //顶部标题
export { default as navigation } from './navigation.vue'; //顶部导航
export { default as mainDrawing } from './mainDrawing.vue'; //主图模块
export { default as product } from './product.vue'; //产品须知
export { default as clause } from './clause.vue'; //条款须知
export { default as guarantee } from './guarantee.vue'; //保障责任
export { default as claims } from './claims.vue'; //理赔流程
export { default as information } from './information.vue'; //我要投保
export { default as bottomButton } from './bottomButton.vue'; //底部按钮
export { default as informationConfirmation } from './informationConfirmation.vue'; //确认信息
export { default as trial } from './trial.vue'; //保费试算
export { default as inform } from './inform.vue'; //健康告知
export { default as disclosureIcp } from './disclosureIcp.vue'; //披露页、icp
export { default as productList } from './productList.vue'; //产品列表
export { default as queryInfo } from './queryInfo.vue'; //查询记录
export { default as policyCancel } from './policyCancel.vue'; //退保填写
export { default as policyDetail } from './policyDetail.vue'; //保单详情
export { default as invoice } from './invoice.vue'; //发票填写
export { default as invoiceList } from './invoiceList.vue'; //开具发票
export { default as invoiceRecordList } from './invoiceRecordList.vue'; //开票记录
export { default as invoiceDetail } from './invoiceDetail.vue'; //发票详情